import cz from './czech';
import gen from './general';

const texts = {
  cz
};

const getLang = () => {
  let lang = "cz";
  let langFromSession = localStorage.getItem("lang");
  if (!langFromSession) {
    localStorage.setItem("lang", "cz");
  }
  else {
    lang = langFromSession;
  }

  return {
    gen,
    langs: texts[lang]
  };
};

export default getLang();



// WEBPACK FOOTER //
// ./src/texts/index.js